import { atom } from 'jotai';

export type LineItemPhotoModalState = {
  isOpen: boolean;
  lineItemId: string | null;
};

export const $lineItemPhotoModalState = atom<LineItemPhotoModalState>({
  isOpen: false,
  lineItemId: null,
});

export const $openLineItemPhotoModal = atom(
  null,
  (get, set, lineItemId: string) => {
    set($lineItemPhotoModalState, {
      isOpen: true,
      lineItemId,
    });
  },
);

export const $closeLineItemPhotoModal = atom(null, (get, set) => {
  set($lineItemPhotoModalState, {
    isOpen: false,
    lineItemId: null,
  });
});
